import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

export interface LinkNavItem {
  label: string;
  value: string;
}

/**
 * Figma-style horizontal link navigation (non-tab) used for in-page section switching.
 */
@Component({
  selector: 'app-link-nav',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './link-nav.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./link-nav.component.scss'],
})
export class LinkNavComponent {
  @Input() items: LinkNavItem[] = [];
  @Input() activeValue = '';
  @Input() ariaLabel = 'Navigation';

  @Output() itemSelect = new EventEmitter<string>();

  onItemSelect(value: string): void {
    if (value !== this.activeValue) {
      this.itemSelect.emit(value);
    }
  }

  isActive(value: string): boolean {
    return this.activeValue === value;
  }

  trackByIndex(index: number): number {
    return index;
  }
}
